var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"absolute inset-0 rounded-full",staticStyle:{"opacity":"0.5","background-image":"url('/img/editor/zodiac/stars.svg')"}})
}
var staticRenderFns = []

export { render, staticRenderFns }